import React, { useContext, useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { BsArrowUpShort } from 'react-icons/bs'
import { isEmpty, startCase } from 'lodash'
import Pagination from 'pages/Pagination'
import pathObj from 'utils/apiPath'
import { apiGet } from 'utils/apiFetch'
import OImage from './OImage'
import homeImg from '../../assets/images/home.png'
import { NavLink } from 'react-router-dom'
import { TAB_PROPERTY_DETAILS } from 'pages/company_manager/CompanyViewPage'
import AuthContext from 'context/AuthContext'

const OPropertyListing = ({ companyId = '', agentId = '' }) => {

  const { setTab } = useContext(AuthContext)
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [list, setList] = useState([])
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const fetchProperties = async () => {
    try {
      const payload = {
        page,
        pageSize
      }
      let path = ''
      if (!isEmpty(companyId)) {
        payload.companyId = companyId
        path = pathObj.getCompanyPropertyList
      }
      if (!isEmpty(agentId)) {
        payload.agentId = agentId
        path = pathObj.agentProperties
      }

      const result = await apiGet(path, payload)
      const response = result?.data?.results
      const resultStatus = result?.data?.success
      setList(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null
      })
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message)
    }
  }
  useEffect(() => {
    fetchProperties()
    setTab(TAB_PROPERTY_DETAILS)
  }, [page])
  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  const [sort, setSort] = useState({
    sortKey: 'createdAt',
    sortType: 'desc'
  })
  const { t } = useTranslation()

  return (
    <>
      <div className='p-3'>
        <div className='overflow-x-auto relative 
 border'>
          <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
            <thead className='text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
              <tr>
                <th scope='col' className='py-3 px-6'>
                  #
                </th>
                <th scope='col' className='py-3 px-6 '>
                  {t('Photo')}
                </th>
                <th
                  scope='col'
                  className='py-3 px-6 cursor-pointer'
                  onClick={() => {
                    if (sort.sortKey === 'email' && sort.sortType === 'asc') {
                      setSort({
                        sortKey: 'email',
                        sortType: 'desc'
                      })
                    } else {
                      setSort({
                        sortKey: 'email',
                        sortType: 'asc'
                      })
                    }
                  }}
                >
                  <div className='flex'>
                    <span>{t('O_PROPERTY_TITLE')} </span>
                    <span>
                      {sort.sortKey === 'email' && sort.sortType === 'asc' && (
                        <BsArrowUpShort className='w-4 h-4' />
                      )}
                      {sort.sortKey === 'email' && sort.sortType === 'desc' && (
                        <BsArrowUpShort className='w-4 h-4 rotate-180' />
                      )}
                    </span>
                  </div>
                </th>
                <th
                  scope='col'
                  className='py-3 px-6 cursor-pointer'
                  onClick={() => {
                    if (sort.sortKey === 'name' && sort.sortType === 'asc') {
                      setSort({
                        sortKey: 'name',
                        sortType: 'desc'
                      })
                    } else {
                      setSort({
                        sortKey: 'name',
                        sortType: 'asc'
                      })
                    }
                  }}
                >
                  <div className='flex'>
                    <span>{t('O_PROPERTY_ID')} </span>
                    <span>
                      {sort.sortKey === 'name' && sort.sortType === 'asc' && (
                        <BsArrowUpShort className='w-4 h-4' />
                      )}
                      {sort.sortKey === 'name' && sort.sortType === 'desc' && (
                        <BsArrowUpShort className='w-4 h-4 rotate-180' />
                      )}
                    </span>
                  </div>
                </th>
                <th scope='col' className='py-3 px-6 '>
                  {t('PROPERTY_CATEGORY')}
                </th>

                <th
                  scope='col'
                  className='py-3 px-6 cursor-pointer'
                  onClick={() => {
                    if (sort.sortKey === 'email' && sort.sortType === 'asc') {
                      setSort({
                        sortKey: 'email',
                        sortType: 'desc'
                      })
                    } else {
                      setSort({
                        sortKey: 'email',
                        sortType: 'asc'
                      })
                    }
                  }}
                >
                  <div className='flex'>
                    <span>{t('O_AGENT_NAME')} </span>
                    <span>
                      {sort.sortKey === 'email' && sort.sortType === 'asc' && (
                        <BsArrowUpShort className='w-4 h-4' />
                      )}
                      {sort.sortKey === 'email' && sort.sortType === 'desc' && (
                        <BsArrowUpShort className='w-4 h-4 rotate-180' />
                      )}
                    </span>
                  </div>
                </th>
                <th scope='col' className='py-3 px-6 '>
                  {t('O_STATUS')}
                </th>
                {/* <th scope='col' className='py-3 px-6 '>
                  {t('APPROVED_STATUS')}
                </th> */}

                <th scope='col' className='py-3 px-6 text-center'>
                  {t('O_ACTION')}
                </th>
              </tr>
            </thead>
            <tbody>
              {list &&
                list?.map((item, i) => (
                  <tr
                    key={i}
                    className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'
                  >
                    <th
                      scope='row'
                      className='p-2 border-r font-medium text-gray-900  dark:text-white'
                    >
                      {i + 1 + 10 * (paginationObj?.page - 1)}
                    </th>
                    <td className='p-2 border-r text-center'>
                      <figure className='inline-block overflow-hidden rounded-full border-2 mb-0'>
                        <OImage
                          src={
                            item?.photos?.length >= 1
                              ? item?.photos[0]
                              : homeImg
                          }
                          className='w-10 h-w-10'
                          fallbackUrl={homeImg}
                        />
                      </figure>
                    </td>
                    <td className='p-2 border-r'>
                      {startCase(item?.title)}
                    </td>
                    <td className='p-2 border-r'>{item?.propertyId} </td>
                    <td className='p-2 border-r'>
                      {startCase(item?.propertyCategory?.name) || 'N/A'}
                    </td>
                    <td className='p-2 border-r'>
                      {item?.agent?.firstName
                        ? startCase(item?.agent?.firstName) +
                        ' ' +
                        startCase(item?.agent?.lastName)
                        : 'N/A'}
                    </td>
                    <td className='p-2 text-center'>
                      {startCase(item?.status)}
                    </td>
                    {/* <td className='p-2 text-center border-l'>
                      {startCase(item?.isApprovedStatus)}
                    </td> */}
                    <td className='p-2 border-l'>
                      <div className=''>
                        <ul className='flex justify-center'>
                          <>
                            {/* <li
                              className='px-2 py-2 hover:bg-white hover:text-LightBlue cursor-pointer'
                              onClick={() => handleUserView(item)}
                            >
                              <AiFillEye className=' w-5 h-5 text-slate-600' />{' '}
                            </li> */}
                            <NavLink
                              to={`/properties/view/${item._id}`}
                              state={{ item, view: 'propertyView', tab: TAB_PROPERTY_DETAILS, propertyId:item._id }}
                              // state={{ item }}
                              className='hover:bg-white hover:text-LightBlue cursor-pointer'
                            >
                              <button className='bg-[#8FC150] text-sm p-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] sm:w-auto'>{t('O_VIEW_PROPERTY_DETAILS')}</button>
                            </NavLink>
                          </>
                        </ul>
                      </div>
                    </td>
                  </tr>
                ))}
              {isEmpty(list) && (
                <tr className='bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700'>
                  <td className='py-4 px-6' colSpan={13}>
                    {t('O_NO_RECORD_FOUND')}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {paginationObj?.totalItems > 0 && (
        <Pagination
          handlePageClick={handlePageClick}
          options={paginationObj}
          page={page}
        />
      )}
    </>
  )
}

export default OPropertyListing
